import Company from "../../../../components/units/Management/Company/CompanyList";

export default function CompanyListPage() {
  return <Company />;
}
